import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useActiveContextReady } from './useActiveContextReady';
import { config } from '../config';

const backendApi = config.backendApi;

export interface ResourceLimitStatus {
  softLimit: number;
  currentCount: number;
  approachingLimit: boolean;
  atLimit: boolean;
}

export interface OrgLimitsResponse {
  devices: ResourceLimitStatus;
  gateways: ResourceLimitStatus;
  users: ResourceLimitStatus;
  regions: ResourceLimitStatus;
}

const fetchResourceLimits = async (): Promise<OrgLimitsResponse> => {
  const response = await axios.get<OrgLimitsResponse>(
    `${backendApi}/api/billing/limits`,
    { withCredentials: true }
  );
  return response.data;
};

export function useResourceLimits(enabled = true) {
  const contextReady = useActiveContextReady();

  return useQuery<OrgLimitsResponse>({
    queryKey: ['billing', 'limits'],
    queryFn: fetchResourceLimits,
    enabled: enabled && contextReady,
    staleTime: 30000,
    refetchInterval: 60000,
  });
}
